import { put, takeEvery, all } from 'redux-saga/effects';
import * as constants from '../constants/all';
import * as userHomeActions from '../actions/userHome';
import { Log } from 'ng2-logger';
import { UserHomeService } from '../../api/user-home-service';
import Translator from '../../core/i18n';
import * as coreActions from '../actions/core';
import { Common } from '../../core/common';
import { CacheService } from '../../core/cacheService';
import { IActionRequestDate } from '../../models/core/action-request';
const T = Translator.create();
const _logger = Log.create('UserHome Sagas');
const _common = new Common();
const _cacheService = new CacheService();
const userHomeServiece = new UserHomeService();

function* setUserHomeCalendarActivitiesData(params: any): any {
    try {
        let takeParam = 0;
        if (params.take && params.take === -1) {
            takeParam = 9999;
        } else if (params.take && params.take > 0) {
            takeParam = params.take;
        } else { takeParam = 10; }
        const newParams = {
            Filter: params.filter,
            StartDate: params.startDate,
            EndDate: params.endDate,
            ContextType: params.contextType,
            ContextId: params.contextId,
            Take: takeParam,
            Skip: params.skip
        };
        yield put(userHomeActions.setUserCalendarActivities(null, false, 0, 0));
        const pageData = yield userHomeServiece.RequestGetUserCalendarActivitiesAsync(newParams).then((responseData: Response) => {
            return responseData;
        }).then((data: any | null) => {
            return data;
        });
        yield put(userHomeActions.setUserCalendarActivities(pageData, true, params.take, params.skip, params.spinnerId, 'set', params.isNowThenPast));
        if (params.callback) {
            params.callback(pageData);
        }
    } catch (error: any) {
        yield put(coreActions.newNotification(T.t('r_user_home_calendar_error_message')));
        yield put(userHomeActions.setUserCalendarActivities(null, true, 0, 0));
    }
}
function* setUserHomeMyCoursesData(params: any) : any {

    const cacheData: IActionRequestDate = { firstRequestDate: new Date(), actionName: params.type };
    if (!_cacheService.CheckCache(cacheData) 
    && !params.filters.SearchCourseName || !params.filters.SearchTermId || !params.filters.SearchProgId || !params.filters.MasterCourseId || !params.filters.status ) {
        _cacheService.AddOrUpdateActionRequest(cacheData);
        try {

            // set loading variable false
            // yield put(userHomeActions.setUserHomeMyCourses(null));
            const resultData = yield userHomeServiece.RequestGetMyCoursesAsync(params.isTeacher, params.searchText, params.filters).then((responseData: Response) => {
                return responseData;
            }).then((data: any | null) => {
                return data;
            });
            yield put(userHomeActions.setUserHomeMyCourses(resultData, params.spinnerId, 'set'));
            if(params.filters){
                yield put(userHomeActions.setSearchFilters(params.filters,'setSearchFilters','set'))
            }
        } catch (error: any) {
            yield put(coreActions.newNotification(T.t('r_my_user_my_courses_error_mesage')));
            yield put(userHomeActions.setUserHomeMyCourses(null, params.spinnerId, 'set'));
        }
    } else {
        yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        
    }
}
function* setUpcomingActivitiesData(params: any): any {
    try {
        const resultData = yield userHomeServiece.RequestGetUpcomingActivitiesAsync(params).then((responseData: Response) => {
            return responseData;
        }).then((data: any | null) => {
            return data;
        });
        yield put(userHomeActions.setUserHomeUpcomingActivities(resultData, params.spinnerId, 'set'));
    } catch (error: any) {
        yield put(coreActions.newNotification(T.t('r_my_user_upcoming_Activities_error_mesage')));
        yield put(userHomeActions.setUserHomeUpcomingActivities(undefined, params.spinnerId, 'set'));
    }
}

export function* watchGetUserHomeMyCoursesData() {
    yield takeEvery(constants.userHomeActions.GET_USER_HOME_MY_COURSES, setUserHomeMyCoursesData);
    return null;
}

export function* watchGetUserHomeCalendarActivitiesData() {
    yield takeEvery(constants.userHomeActions.GET_USER_HOME_CALENDAR_ACTIVITIES, setUserHomeCalendarActivitiesData);
    return null;
}
export function* watchGetUpcomingActivitiesData() {
    yield takeEvery(constants.userHomeActions.GET_USER_UPCOMING_ACTIVITIES, setUpcomingActivitiesData);
    return null;
}

export function* UserHomeSagas() {
    yield all([
        watchGetUserHomeCalendarActivitiesData(),
        watchGetUserHomeMyCoursesData(),
        watchGetUpcomingActivitiesData()
    ]);
}
